module.exports = __webpack_public_path__ + "img/wood-decors.4b461ce1.jpg";